<template>
<!-- CONTENT -->
<section class="main home_content">
  <div class="main_content">
    <!-- Introduction -->
    <h1>Agence nationale des fréquences (ANFR)</h1>
    <h2>L’outil dédié aux antennistes, proposé par l'ANFR</h2>
    <p class="introduction">Retrouvez dès maintenant l'emplacement sur tout le territoire national des stations 4G et des émetteurs TNT, y compris ceux concernés par un incident connu par l'ANFR.</p>
    <!-- 3 laius sur les fonctionnalités -->
    <div class="screed">
      <div @click="onClick('cartographies')">
        <img src="../../assets/img/screed-map.svg" alt="Icone Carte" />
        <h3>Cartographie des antennes 4G et émetteurs TNT</h3>
        <p>Géolocalisez-vous ou recherchez une adresse sur la carte pour voir les antennes situées dans les environs.</p>
      </div>
      <div @click="onClick('incidents')">
        <img src="../../assets/img/screed-incident.svg" alt="Icone Liste" />
        <h3>Liste des incidents TNT</h3>
        <p>Obtenez en temps réel la liste des antennes TNT pour lesquelles un incident a été détecté.</p>
      </div>
      <div @click="onClick('parametrages')">
        <img src="../../assets/img/screed-alert.svg" alt="Icone Alertes" />
        <h3>Recevez des alertes !</h3>
        <p>Paramétrez vos préférences et vos notifications quand un incident sur un émetteur TNT est signalé.</p>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import storeJs from 'store'
import * as eventTypes from '../../bus/event-types.js'
import EventBus from '../../bus'
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      userId: storeJs.get('prtv:user-id'),
      userPartenaire: storeJs.get("prtv:user-partenaire")
    }
  },
  mounted() {
    EventBus.$on(eventTypes.EVENT_USER_INFO, () => {
      this.userId = storeJs.get('prtv:user-id');
      this.userPartenaire = storeJs.get("prtv:user-partenaire");
    })
  },
  methods: {
    alertNotAuthorized(icone) {
      var message = "Vous devez être connecté pour utiliser cette fonctionnalité";
      if (icone == 'parametrages') {
        message = "Vous devez être connecté en tant qu'antenniste partenaire pour utiliser cette fonctionnalité";
      }
      this.$notify({
        group: 'general-notification',
        type: 'error',
        text: message
      })
    },
    onClick(icone) {
      if ((icone == "cartographies" || icone == "incidents") && !this.userId || (icone == "parametrages" && !this.userPartenaire)) {
        this.alertNotAuthorized(icone);
      } else {
        this.$router.push('/' + icone);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.screed div {
  cursor: pointer;
}

.screed div:hover {
  background-color: rgba(40, 40, 40, 0.8);
  -webkit-transition: background-color .5s linear;
  transition: background-color .5s linear;
}
</style>
